module.exports = __webpack_public_path__ + "img/ctrl-st-stub-down-0.42a8ea08.svg";